import { render, staticRenderFns } from "./LayoutSchool.vue?vue&type=template&id=39bc123c&scoped=true"
import script from "./LayoutSchool.vue?vue&type=script&lang=js"
export * from "./LayoutSchool.vue?vue&type=script&lang=js"
import style0 from "./LayoutSchool.vue?vue&type=style&index=0&id=39bc123c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc123c",
  null
  
)

export default component.exports